import { Alert, Link, Typography } from '@mui/material';
import { SlackChannel } from 'generated/graphql';
import pluralize from 'pluralize';

interface PrivateSlackChannelConnectionAlertProps {
  channels: SlackChannel[];
  isSubscriptionReporting?: boolean;
}

const INBOUND_PRIVATE_SLACK_CONNECTION_HELP_CENTER_DOC =
  'https://helpcenter.enterpret.com/en/articles/6320459-slack-inbound-integration#h_1e0325669a';

const OUTBOUND_PRIVATE_SLACK_CONNECTION_HELP_CENTER_DOC =
  'https://helpcenter.enterpret.com/en/articles/8116431-reports-in-enterpret#h_500573ec75';

export const PrivateSlackChannelConnectionAlert = ({
  channels,
  isSubscriptionReporting = false,
}: PrivateSlackChannelConnectionAlertProps) => {
  const channelText = channels.map((channel) => `"${channel.name}"`).join(', ');

  const helpCenterDocLink = isSubscriptionReporting
    ? OUTBOUND_PRIVATE_SLACK_CONNECTION_HELP_CENTER_DOC
    : INBOUND_PRIVATE_SLACK_CONNECTION_HELP_CENTER_DOC;

  return (
    <Alert severity="info" sx={{ alignItems: 'center' }}>
      <Typography variant="body2">
        Please ensure that the private Slack{' '}
        {pluralize('channel', channels.length)} {channelText}{' '}
        {pluralize('has', channels.length)} the Enterpret{' '}
        {isSubscriptionReporting ? 'Bot' : 'App'} added. This would allow
        Enterpret to {isSubscriptionReporting ? 'send reports.' : 'fetch data.'}
      </Typography>
      <Link href={helpCenterDocLink} target="_blank">
        See how to add
      </Link>
    </Alert>
  );
};
